import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setHeading } from "../../redux/slice/headerSlice";
import {
  setActiveCardTab,
  setActiveMembershipTab,
  setMemberShip,
} from "../../redux/slice/membershipSlice";
import { FOUNDER_CLUB, GOLD, PLATINUM, SILVER } from "../../utils/constant";
import { customerView } from "../auth/auth";
import Loader from "../partial/Loader";
import Header from "../layout/Header";
import { formatPoints } from "../../utils/helper";

const Membership = () => {
  const navigate = useNavigate();
  const tiers = localStorage.getItem("customerTier");
  const dispatch = useDispatch();
  const [profileData, setProfileData] = useState();
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const activeMembershipTab = useSelector(
    (state) => state.membership.activeMembershipTab
  );
  const pointsData = location?.state?.pointsData
  const activeCardTab = useSelector((state) => state.membership.activeCardTab);

  const tierOrder = ["Silver", "Gold", "Platinum", "Founder Club"];


  useEffect(() => {
    dispatch(setHeading("Membership"));
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab");

    if (tab === "benefits") {
      dispatch(setActiveMembershipTab(0));
    } else {
      dispatch(setActiveMembershipTab("Upgrade"));
    }
  }, [dispatch, location]);

  useEffect(() => {
    dispatch(setMemberShip(tiers));
    dispatch(setActiveCardTab(tiers));
  }, [dispatch]);

  const handleMembershipTabClick = (tab) => {
    dispatch(setActiveMembershipTab(tab));
  };
  const token = JSON.parse(localStorage.getItem("token_gen"));
  useEffect(() => {
    setLoader(true);
    const customerCode = localStorage.getItem("customercode");

    const customerPromise = customerView(token.access_token, customerCode);
    Promise.all([customerPromise])
      .then(([profileData]) => {
        setProfileData(profileData?.customer || []);
      })
      .catch((error) => {
      })
      .finally(() => {
        setLoader(false);
      });
  }, []);

  const handleCardTabClick = (tab) => {
    dispatch(setActiveCardTab(tab));
    dispatch(setMemberShip(tab));
  };

  const getNextTier = (currentTier) => {
    const tier = currentTier?.toLowerCase();
    const tierAmounts = {
      silver: { name: "Silver", amount: 20000000, next: { name: "Gold", amount: 50000000 } },
      gold: { name: "Gold", amount: 50000000, next: { name: "Platinum", amount: 120000000 } },
      platinum: { name: "Platinum", amount: 120000000, next: { name: "Founder`s Club", amount: 350000000 } },
      foundersclub: { name: "Founder`s Club", amount: 350000000, next: null },
    };
    return tierAmounts[tier] || { name: "Unknown", amount: 0, next: null };
  };


  const getNextTiers = (currentTier) => {
    const tier = currentTier?.toLowerCase();
    const tierAmounts = {
      silver: { name: "Silver", percent: "50%", vintage: 3, overdue: "5% in 3 months", next: { name: "Gold", percent: "60%", vintage: 6, overdue: "5% in 6 months" } },
      gold: { name: "Gold", percent: "60%", vintage: 6, overdue: "5% in 6 months", next: { name: "Platinum", percent: "65%", vintage: 9, overdue: "5% in 9 months" } },
      platinum: { name: "Platinum", percent: "65%", vintage: 9, overdue: "5% in 9 months", next: { name: "Founder`s Club", percent: "70%", vintage: 12, overdue: "5% in 12 months" } },
      foundersclub: { name: "Founder`s Club", percent: "70%", vintage: 12, overdue: "5% in 12 months", next: null },
    };
    return tierAmounts[tier] || { name: "Unknown", amount: 0, vintage: 0, overdur: "", next: null };
  };

  const toCrores = (amount) => (amount / 10000000).toFixed(2);

  const currentTierData = getNextTier(tiers);
  const nextTier = currentTierData.next;

  const currentTiers = getNextTiers(tiers);
  const nextTierDatas = currentTiers.next;
  const prcntlimitutilization = parseFloat(profileData?.prcntlimitutilization) || 0
  const nextprcntlimitutilization = nextTierDatas ? parseFloat(nextTierDatas.percent) : 0;

  const pendingpercent = nextTierDatas ? nextprcntlimitutilization - prcntlimitutilization : 0;
  const ispercentAchieved = nextTierDatas && prcntlimitutilization >= nextprcntlimitutilization;
  const progressacheived = nextTierDatas ? Math.min((prcntlimitutilization / nextprcntlimitutilization) * 100, 100) : 0;

  const currentThroughput = parseFloat(profileData?.currentThroughput) || 0;
  const nextTierAmount = nextTier ? parseFloat(nextTier.amount) : 0;
  const pendingAmount = nextTier ? toCrores(nextTierAmount - currentThroughput) : 0;
  const isMilestoneAchieved = nextTier && currentThroughput >= nextTierAmount;
  const progressPercentage = nextTier ? Math.min((currentThroughput / nextTierAmount) * 100, 100) : 0;

  const getNextAUMTier = (currentAUM) => {
    const tier = currentAUM?.toLowerCase();
    const tierAmounts = {
      silver: { name: "Silver", amount: 3500000, next: { name: "Gold", amount: 10000000 } },
      gold: { name: "Gold", amount: 10000000, next: { name: "Platinum", amount: 20000000 } },
      platinum: { name: "Platinum", amount: 20000000, next: { name: "Founder`s Club", amount: 50000000 } },
      foundersclub: { name: "Founder`s Club", amount: 50000000, next: null },
    };
    return tierAmounts[tier] || { name: "Unknown", amount: 0, next: null };
  };

  const currentTierDatas = getNextAUMTier(tiers);
  const nextTiers = currentTierDatas.next;
  const currentThroughputs = parseFloat(profileData?.currentAUM) || 0;
  const nextTierAmounts = nextTiers ? parseFloat(nextTiers.amount) : 0;
  const pendingAmounts = nextTiers ? toCrores(nextTierAmounts - currentThroughputs) : 0;
  const isMilestoneAchieveds = nextTiers && currentThroughputs >= nextTierAmounts;
  const progressPercentages = nextTiers ? Math.min((currentThroughputs / nextTierAmounts) * 100, 100) : 0;

  const getNextRetailer = (currentAUM) => {
    const tier = currentAUM?.toLowerCase();
    const tierAmounts = {
      silver: { name: "Silver", amount: 3, next: { name: "Gold", amount: 10 } },
      gold: { name: "Gold", amount: 10, next: { name: "Platinum", amount: 15 } },
      platinum: { name: "Platinum", amount: 15, next: { name: "Founder`s Club", amount: 30 } },
      foundersclub: { name: "Founder`s Club", amount: 30, next: null },
    };
    return tierAmounts[tier] || { name: "Unknown", amount: 0, next: null };
  };
  const currentVintage = parseFloat(profileData?.vintageinmonths) || 0;
  const currentTierVintage = getNextTiers(tiers);
  const nextVintage = currentTierVintage.next;
  const nextTierVintage = nextVintage ? parseFloat(nextVintage.vintage) : 0;
  const pendingVintage = nextVintage ? (nextTierVintage - currentVintage) : 0;
  const isMilestoneVintage = nextVintage && currentVintage >= nextTierVintage;
  const progressPercentagesVintage = nextVintage ? Math.min((currentVintage / nextTierVintage) * 100, 100) : 0
  const currentOverdue = parseFloat(profileData?.npa) || 0;
  const currentTierOverdue = getNextTiers(tiers);
  const nextOverdue = currentTierOverdue.next;
  const nextTierOverdue = nextOverdue ? parseFloat(nextOverdue.overdue) : 0;
  const pendingOverdue = nextOverdue ? (currentOverdue - 0) : 0;
  const isMilestoneOverdue = nextOverdue && 0 == currentOverdue;
  const progressPercentagesOverdue = nextOverdue
    ? currentOverdue === 0
      ? 100
      : Math.max(100 - currentOverdue, 0)
    : 0;

  const currentTierRetailer = getNextRetailer(tiers);
  const nextRetailer = currentTierRetailer.next;
  const currentRetailer = parseFloat(profileData?.currentcountofactiveretailers) || 0;
  const nextTierRetailer = nextRetailer ? parseFloat(nextRetailer.amount) : 0;
  const pendingRetailer = nextRetailer ? (nextTierRetailer - currentRetailer) : 0;
  const isMilestoneRetailer = nextRetailer && currentRetailer >= nextTierRetailer;
  const progressPercentagesRetailer = nextRetailer ? Math.min((currentRetailer / nextTierRetailer) * 100, 100) : 0;

  const currentTierIndex = tierOrder.indexOf(tiers);
  const nextTierName = currentTierIndex < tierOrder.length - 1 ? tierOrder[currentTierIndex + 1] : null;
  const getTierMessage = (tier) => {
    const currentTierIndex = tierOrder.indexOf(tiers);
    const nextTierName = currentTierIndex < tierOrder.length - 1 ? tierOrder[currentTierIndex + 1] : null;

    if (tier === tiers) {
      return <p>You are currently here</p>;
    } else if (tier === nextTierName) {
      return (
        <p className={`${tier.toLowerCase()}_benefits`} style={{ cursor: "pointer" }} onClick={() => dispatch(setActiveMembershipTab("Upgrade"))}>
          {(profileData?.tierachievedpercent) || "0"}% Achieved  <br />
          View details in the Upgrade Membership tab

        </p>
      );
    } else if (tierOrder.indexOf(tier) < currentTierIndex) {
      return null;
    } else if (tierOrder.indexOf(tier) > currentTierIndex + 1) {
      return <p>Enjoy a {activeCardTab === PLATINUM ? "2x" : "2.5x"} points multiplier on every transaction.</p>
    }
    return null;
  };
  const goToPreviousTab = () => {
    navigate(-1);
  };
  const industry = localStorage.getItem('industry');
  const industryTransactionMap = {
    'White Goods': 10000,
    'Steel': 10000,
    'Battery': 10000,
    'Ceramics': 10000,
    'Construction': 10000,
    'Spare': 10000,
    'Footwear': 10000,
    'Glass & Plywood': 10000,
    'Plywood': 10000,
    'Glass': 10000,
    'Mobile': 20000,
    '2 Wheelers': 12500,
    'Agri Inputs': 8000,
    "FMCG": 10000
  };
  const transactionValue = industryTransactionMap[industry]

  return (
    <>
      <Header goToPreviousTab={goToPreviousTab} isHomePage={false} />
      <main>
        {loader && <Loader />}
        <section>
          <div className="membership">
            <div className="membership-header">
              <ul>
                <li
                  className={activeMembershipTab === 0 ? "active" : ""}
                  data-item="#mb"
                  data-title="Membership"
                  onClick={() => dispatch(setActiveMembershipTab(0))}
                >

                  <p>Membership Benefits</p>
                </li>
                {tiers === "Founder Club" ? null :
                  <li
                    className={activeMembershipTab === "Upgrade" ? "active" : ""}
                    data-item="#um"
                    data-title="Upgrade"
                    onClick={() => handleMembershipTabClick("Upgrade")}
                  >

                    <p>Upgrade Membership</p>
                  </li>
                }
              </ul>
            </div>
            <div className="membership-body">
              <div className="membership-body-content">
                <div
                  className={`membership-body-content-inner ${activeMembershipTab === 0 ? "active" : ""}`}
                  id="mb"
                >
                  <div className="membership-body-content-inner-box">
                    <div className="membership-body-content-inner-box-list">
                      <ul>
                        <li
                          className={activeCardTab === SILVER ? "active" : ""}
                          data-tab="#silver"
                          onClick={() => handleCardTabClick(SILVER)}
                        >
                          Silver
                        </li>
                        <li
                          className={activeCardTab === GOLD ? "active" : ""}
                          data-tab="#gold"
                          onClick={() => handleCardTabClick(GOLD)}
                        >
                          Gold
                        </li>
                        <li
                          className={activeCardTab === PLATINUM ? "active" : ""}
                          data-tab="#platinum"
                          onClick={() => handleCardTabClick(PLATINUM)}
                        >
                          Platinum
                        </li>
                        <li
                          className={activeCardTab === FOUNDER_CLUB ? "active" : ""}
                          data-tab="#founder"
                          onClick={() => handleCardTabClick(FOUNDER_CLUB)}
                        >
                          Founder`s Club
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div
                    className={`membership-body-content-inner-listBox ${activeCardTab === SILVER ? "active" : ""}`}
                    id="silver"
                  >
                    <div className="membership-body-content-inner-listBox-inner">
                      <div className="membership-body-content-inner-listBox-inner-header">

                        <div className="membership-body-content-inner-listBox-inner-header-right">
                          <h3>Silver Card Benefits</h3>
                          {getTierMessage(SILVER)}
                        </div>
                      </div>
                      <div className="membership-body-content-inner-listBox-inner-body">
                        <div className="membership-body-content-inner-listBox-inner-body-box purple">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="purple">
                              <img src="images/welcome.png" alt="Welcome Bonus" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="purple">Welcome Bonus</h5>
                            <p className="purple">
                              Get 20k points when you join
                            </p>
                          </div>
                        </div>


                        {/* <div className="membership-body-content-inner-listBox-inner-body-box blue">
                        <div className="membership-body-content-inner-listBox-inner-body-box-left">
                          <span className="blue">
                            <img src="images/earn.png" alt="Enhanced Points" />
                          </span>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box-right">
                          <h5 className="blue">Enhanced Points Rate</h5>
                          <p className="blue">
                            Enjoy a 1x Points multiplier on
                            every transaction.
                          </p>
                        </div>
                      </div> */}



                        <div className="membership-body-content-inner-listBox-inner-body-box yellow">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="yellow">
                              <img src="images/upload_earn.png" alt="Upload & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="yellow">Earn on every  Invoice Value</h5>
                            <p className="yellow">
                              Earn 100 points for every{" "}
                              &#x20B9;{formatPoints(transactionValue)} invoice value.
                            </p>
                            <p className="yellow">
                              100 Points= &#x20B9;1
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box orange">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="orange">
                              <img src="images/refer.png" alt="Refer & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="orange">Onboard Retailers & Earn Bonus</h5>

                            <p className="orange">
                              Earn 1 Lakh bonus points for each successful retailer referral
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box orangelite">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="orange">
                              <img src="images/refer.png" alt="Refer & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="orange">Refer & Earn BIG!</h5>

                            <p className="orange">
                              Refer Distributors & Brands in your network & earn points equal to their 30 day business volume with Progcap. Earn upto  &#x20B9;10K/distributor & &#x20B9;50K/brand
                            </p>
                          </div>
                        </div>
                        {/* <div className="membership-body-content-inner-listBox-inner-body-box green">
                        <div className="membership-body-content-inner-listBox-inner-body-box-left">
                          <span className="green">
                            <img src="images/erp.png" alt="ERP Rewards" />
                          </span>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box-right">
                          <h5 className="green">Daily ERP Rewards</h5>
                          <p className="green">
                            Keep ERP synced and earn <span className="green">1K points</span>{" "}
                            every day.
                          </p>
                        </div>
                      </div> */}
                        <div className="membership-body-content-inner-listBox-inner-body-box red">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="red">
                              <img src="images/event.png" alt="Event Invites" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="red">Event Invites</h5>
                            <p className="red">Get exclusive access to annual Progcap events.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`membership-body-content-inner-listBox ${activeCardTab === GOLD ? "active" : ""}`}
                    id="gold"
                  >
                    <div className="membership-body-content-inner-listBox-inner">
                      <div className="membership-body-content-inner-listBox-inner-header">

                        <div className="membership-body-content-inner-listBox-inner-header-right">
                          <h3>Gold Card Benefits</h3>
                          {getTierMessage(GOLD)}
                        </div>
                      </div>
                      <div className="membership-body-content-inner-listBox-inner-body">
                        <div className="membership-body-content-inner-listBox-inner-body-box purple">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="purple">
                              <img src="images/welcome.png" alt="Welcome Bonus" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="purple">Welcome Bonus</h5>
                            <p className="purple">
                              Get 30k points when you join
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box blue">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="blue">
                              <img src="images/earn.png" alt="Enhanced Points" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="blue">Enhanced Points Rate</h5>
                            <p className="blue">
                              Enjoy a 1.5x Points multiplier on
                              every transaction
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box yellow">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="yellow">
                              <img src="images/upload_earn.png" alt="Upload & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="yellow">Earn on every Invoice</h5>
                            <p className="yellow">
                              Earn 150 points for every{" "}
                              &#x20B9;{formatPoints(transactionValue)} invoice value.
                            </p>
                            <p className="yellow">
                              100 Points= &#x20B9;1
                            </p>
                          </div>
                        </div>


                        {/* <div className="membership-body-content-inner-listBox-inner-body-box orange">
                        <div className="membership-body-content-inner-listBox-inner-body-box-left">
                          <span className="orange">
                            <img src="images/refer.png" alt="Refer & Earn" />
                          </span>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box-right">
                          <h5 className="orange">Refer & Earn</h5>
                          <p className="orange">
                            Refer a brand, distributor, or retailer and get{" "}
                            1% of their 30-day business in
                            points.
                          </p>
                        </div>
                      </div> */}
                        <div className="membership-body-content-inner-listBox-inner-body-box orange">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="orange">
                              <img src="images/refer.png" alt="Refer & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="orange">Onboard Retailers & Earn Bonus</h5>

                            <p className="orange">
                              Earn 1 Lakh bonus points for each successful retailer referral
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box orangelite">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="orange">
                              <img src="images/refer.png" alt="Refer & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="orange">Refer & Earn BIG!</h5>

                            <p className="orange">
                              Refer Distributors & Brands in your network & earn points equal to their 30 day business volume with Progcap. Earn upto  &#x20B9;10K/distributor & &#x20B9;50K/brand
                            </p>
                          </div>
                        </div>
                        {/* <div className="membership-body-content-inner-listBox-inner-body-box green">
                        <div className="membership-body-content-inner-listBox-inner-body-box-left">
                          <span className="green">
                            <img src="images/erp.png" alt="ERP Rewards" />
                          </span>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box-right">
                          <h5 className="green">Daily ERP Rewards</h5>
                          <p className="green">
                            Keep ERP synced and earn <span className="green">1.5K points</span>{" "}
                            every day.
                          </p>
                        </div>
                      </div> */}
                        <div className="membership-body-content-inner-listBox-inner-body-box red">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="red">
                              <img src="images/event.png" alt="Event Invites" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="red">Event Invites</h5>
                            <p className="red">Get exclusive access to annual Progcap events.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`membership-body-content-inner-listBox ${activeCardTab === PLATINUM ? "active" : ""}`}
                    id="platinum"
                  >
                    <div className="membership-body-content-inner-listBox-inner">
                      <div className="membership-body-content-inner-listBox-inner-header">

                        <div className="membership-body-content-inner-listBox-inner-header-right">
                          <h3>Platinum Card Benefits</h3>
                          {getTierMessage(PLATINUM)}
                        </div>
                      </div>
                      <div className="membership-body-content-inner-listBox-inner-body">
                        <div className="membership-body-content-inner-listBox-inner-body-box purple">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="purple">
                              <img src="images/welcome.png" alt="Welcome Bonus" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="purple">Welcome Bonus</h5>
                            <p className="purple">
                              Get 50k points when you join
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box blue">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="blue">
                              <img src="images/earn.png" alt="Enhanced Points" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="blue">Enhanced Points Rate</h5>
                            <p className="blue">
                              Enjoy a 2x points multiplier on every
                              transaction
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box yellow">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="yellow">
                              <img src="images/upload_earn.png" alt="Upload & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="yellow">Earn on Every Invoice</h5>
                            <p className="yellow">
                              Earn 200 points for every{" "}
                              &#x20B9;{formatPoints(transactionValue)} invoice value
                            </p>
                            <p className="yellow">
                              100 Points= &#x20B9;1
                            </p>
                          </div>
                        </div>
                        {/* <div className="membership-body-content-inner-listBox-inner-body-box orange">
                        <div className="membership-body-content-inner-listBox-inner-body-box-left">
                          <span className="orange">
                            <img src="images/refer.png" alt="Refer & Earn" />
                          </span>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box-right">
                          <h5 className="orange">Refer & Earn</h5>
                          <p className="orange">
                            Refer a brand, distributor, or retailer and get{" "}
                            1.5% of their 30-day business in
                            points.
                          </p>
                        </div>
                      </div> */}
                        <div className="membership-body-content-inner-listBox-inner-body-box orange">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="orange">
                              <img src="images/refer.png" alt="Refer & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="orange">Onboard Retailers & Earn Bonus</h5>

                            <p className="orange">
                              Earn 1 Lakh bonus points for each successful retailer referral
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box orangelite">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="orange">
                              <img src="images/refer.png" alt="Refer & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="orange">Refer & Earn BIG!</h5>

                            <p className="orange">
                              Refer Distributors & Brands in your network & earn points equal to their 30 day business volume with Progcap. Earn upto  &#x20B9;10K/distributor & &#x20B9;50K/brand
                            </p>
                          </div>
                        </div>
                        {/* <div className="membership-body-content-inner-listBox-inner-body-box green">
                        <div className="membership-body-content-inner-listBox-inner-body-box-left">
                          <span className="green">
                            <img src="images/erp.png" alt="ERP Rewards" />
                          </span>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box-right">
                          <h5 className="green">Daily ERP Rewards</h5>
                          <p className="green">
                            Keep ERP synced and earn <span className="green">2K points</span>{" "}
                            every day.
                          </p>
                        </div>
                      </div> */}
                        <div className="membership-body-content-inner-listBox-inner-body-box red">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="red">
                              <img src="images/elite.png" alt="Elite Access" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="red">Elite Access</h5>
                            <p className="red">
                              Enjoy exclusive events and rewards available only to Platinum Club
                              members.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`membership-body-content-inner-listBox ${activeCardTab === FOUNDER_CLUB ? "active" : ""}`}
                    id="founder"
                  >
                    <div className="membership-body-content-inner-listBox-inner">
                      <div className="membership-body-content-inner-listBox-inner-header">

                        <div className="membership-body-content-inner-listBox-inner-header-right">
                          <h3>Founder's Club Benefits</h3>
                          {getTierMessage(FOUNDER_CLUB)}
                        </div>
                      </div>
                      <div className="membership-body-content-inner-listBox-inner-body">
                        <div className="membership-body-content-inner-listBox-inner-body-box purple">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="purple">
                              <img src="images/welcome.png" alt="Welcome Bonus" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="purple">Welcome Bonus</h5>
                            <p className="purple">
                              Get 80k points when you join
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box blue">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="blue">
                              <img src="images/earn.png" alt="Enhanced Points" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="blue">Enhanced Points Rate</h5>
                            <p className="blue">
                              Enjoy a 2.5x points multiplier on
                              every transaction
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box yellow">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="yellow">
                              <img src="images/upload_earn.png" alt="Upload & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="yellow">Earn on Every Invoice</h5>
                            <p className="yellow">
                              Earn 250 points for every{" "}
                              &#x20B9;{formatPoints(transactionValue)} invoice value
                            </p>
                            <p className="yellow">
                              100 Points= &#x20B9;1
                            </p>
                          </div>
                        </div>
                        {/* <div className="membership-body-content-inner-listBox-inner-body-box orange">
                         <div className="membership-body-content-inner-listBox-inner-body-box-left">
                          <span className="orange">
                            <img src="images/refer.png" alt="Refer & Earn" />
                          </span>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box-right">
                          <h5 className="orange">Refer & Earn</h5>
                          <p className="orange">
                            Refer a brand, distributor, or retailer and get{" "}
                            2% of their 30-day business in
                            points.
                          </p>
                        </div>
                      </div> */}
                        <div className="membership-body-content-inner-listBox-inner-body-box orange">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="orange">
                              <img src="images/refer.png" alt="Refer & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="orange">Onboard Retailers & Earn Bonus</h5>

                            <p className="orange">
                              Earn 1 Lakh bonus points for each successful retailer referral
                            </p>
                          </div>
                        </div>
                        <div className="membership-body-content-inner-listBox-inner-body-box orangelite">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="orange">
                              <img src="images/refer.png" alt="Refer & Earn" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="orange">Refer & Earn BIG!</h5>

                            <p className="orange">
                              Refer Distributors & Brands in your network & earn points equal to their 30 day business volume with Progcap. Earn upto  &#x20B9;10K/distributor & &#x20B9;50K/brand
                            </p>
                          </div>
                        </div>
                        {/* <div className="membership-body-content-inner-listBox-inner-body-box green">
                        
                        <div className="membership-body-content-inner-listBox-inner-body-box-right">
                          <h5 className="green">Daily ERP Rewards</h5>
                          <p className="green">
                            Keep ERP synced and earn <span className="green">2.5K points</span>{" "}
                            every day.
                          </p>
                        </div>
                      </div> */}
                        <div className="membership-body-content-inner-listBox-inner-body-box red">
                          <div className="membership-body-content-inner-listBox-inner-body-box-left">
                            <span className="red">
                              <img src="images/event.png" alt="Event Invites" />
                            </span>
                          </div>
                          <div className="membership-body-content-inner-listBox-inner-body-box-right">
                            <h5 className="red">Elite Access</h5>
                            <p className="red">
                              Enjoy exclusive events and rewards available only to Founder
                              Club members.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`membership-body-content-inner ${activeMembershipTab === "Upgrade" ? "active" : ""}`}
                  id="um"
                >
                  <div className="membership-body-content-inner-Box">
                    {profileData?.npaBreached?.toLowerCase() === "yes" ? (
                      <div className="alert-box danger mb-15">
                        <div className="alert-box-image">
                          <img src="images/danger.png" alt="Danger Alert" />
                        </div>
                        <div className="alert-box-message">
                          <h5>Membership On Hold</h5>
                          <p>Daily activity streak is not sufficient. Membership upgrade progress is on hold for now.</p>
                        </div>
                      </div>
                    ) : null}
                    {industry === "FMCG" && profileData?.ProgramType === "Primary" ?
                      <>
                        <div className="membership-body-content-inner-Box-header">
                          <h4>{`Upgrade to ${nextTier?.name} tier by meeting these goals`}</h4>
                        </div>


                        <div className="membership-body-content-inner-Box-body">
                          <div className="membership-body-content-inner-Box-body-box">
                            <div className="membership-body-content-inner-Box-body-box-header">
                              <h6>% Limit Utilization</h6>
                              <p>
                                {/* {tiers === "Silver"
    ? "60%"
    : tiers === "Gold"
    ? "65%"
    : tiers === "Platinum" ? "70%" : tiers === "Founder Club" ? "0":0}  */} {`${prcntlimitutilization}%` || 0}
                              </p>
                            </div>
                            <div className="membership-body-content-inner-Box-body-box-body">
                              <div className="membership-body-content-inner-Box-body-box-body-top">
                                <div className="membership-body-content-inner-Box-body-box-body-top-left">
                                  {ispercentAchieved ? `Achieved` : "In Progress"}
                                </div>
                                <div className="membership-body-content-inner-Box-body-box-body-top-right">
                                  {nextTierDatas ? (
                                    pendingpercent > 0 ?
                                      <>
                                        Pending to {nextTierDatas.name}: <span>{pendingpercent > 0 ? pendingpercent : 0}%</span>
                                      </> : ""
                                  ) : (
                                    "No next tier"
                                  )}
                                </div>
                              </div>
                              <div className="membership-body-content-inner-Box-body-box-body-body">
                                <div className="progress-container">
                                  <div className="progress-bar-container">
                                    <div
                                      className="progress-bar"
                                      style={{ width: `${progressacheived}%` }}
                                    ></div>
                                  </div>
                                  <div className="tag silver-tag">
                                    <img src="images/sliver-caret.png" alt="Current Tier Achieved" />
                                    <p>{currentTiers.name}: {currentTiers.percent}</p>
                                  </div>
                                  {nextTierDatas && (
                                    <div className="tag gold-tag">
                                      <img src="images/gold-caret.png" alt="Next Tier Goal" />
                                      <p>{nextTierDatas.name}: {nextTierDatas.percent}</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="membership-body-content-inner-Box-body-box">
                            <div className="membership-body-content-inner-Box-body-box-header">
                              <h6>A	Vintage with Progcap (Minimum Months)</h6>
                              <p>{currentVintage}</p>
                            </div>
                            <div className="membership-body-content-inner-Box-body-box-body">
                              <div className="membership-body-content-inner-Box-body-box-body-top">
                                <div className="membership-body-content-inner-Box-body-box-body-top-left milestone">
                                  {isMilestoneVintage ? `Achieved` : "In Progress"}
                                </div>
                                <div className="membership-body-content-inner-Box-body-box-body-top-right">
                                  {pendingVintage > 0 && (
                                    pendingVintage > 0 ?
                                      <>
                                        Pending to {nextVintage.name}: <span>{pendingVintage > 0 ? pendingVintage : 0}</span>
                                      </> : ""
                                  )}
                                </div>
                              </div>
                              <div className="membership-body-content-inner-Box-body-box-body-body">
                                <div className="progress-container">
                                  <div className="progress-bar-container">
                                    <div
                                      className="progress-bar"
                                      style={{ width: `${progressPercentagesVintage}%` }}
                                    ></div>
                                  </div>
                                  <div className="tag silver-tag">
                                    <img src="images/sliver-caret.png" alt="Silver Achieved" />
                                    <p>{currentTierVintage.name}: {currentTierVintage.vintage}</p>
                                  </div>
                                  {nextVintage && (
                                    <div className="tag gold-tag">
                                      <img src="images/gold-caret.png" alt="Gold Goal" />
                                      <p>{nextVintage.name}: {nextVintage.vintage}</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="membership-body-content-inner-Box-body-box">
                            <div className="membership-body-content-inner-Box-body-box-header">
                              <h6>Overdue</h6>
                              <p>{currentOverdue}</p>
                            </div>
                            <div className="membership-body-content-inner-Box-body-box-body">
                              <div className="membership-body-content-inner-Box-body-box-body-top">
                                <div className="membership-body-content-inner-Box-body-box-body-top-left milestone">
                                  {isMilestoneOverdue ? `Achieved` : "In Progress"}
                                </div>
                                <div className="membership-body-content-inner-Box-body-box-body-top-right">
                                  {pendingOverdue > 0 && (
                                    pendingOverdue > 0 ?
                                      <>
                                        Pending to {nextOverdue.name}: <span>{pendingOverdue > 0 ? pendingOverdue : 0}</span>
                                      </> : ""
                                  )}
                                </div>
                              </div>
                              <div className="membership-body-content-inner-Box-body-box-body-body">
                                <div className="progress-container">
                                  <div className="progress-bar-container">
                                    <div
                                      className="progress-bar"
                                      style={{ width: `${progressPercentagesOverdue}%` }}
                                    ></div>
                                  </div>
                                  <div className="tag silver-tag">
                                    <img src="images/sliver-caret.png" alt="Silver Achieved" />
                                    <p>{currentTierOverdue?.name}: {currentTierOverdue.overdue}</p>
                                  </div>
                                  {nextOverdue && (
                                    <div className="tag gold-tag">
                                      <img src="images/gold-caret.png" alt="Gold Goal" />
                                      <p>{nextOverdue.name}: {nextOverdue.overdue}</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                        </div></>

                      :
                      <>
                        <div className="membership-body-content-inner-Box-header">
                          <h4>{`Upgrade to ${nextTier?.name} tier by meeting these goals`}</h4>
                        </div>


                        <div className="membership-body-content-inner-Box-body">
                          <div className="membership-body-content-inner-Box-body-box">
                            <div className="membership-body-content-inner-Box-body-box-header">
                              <h6>12-Month Throughput</h6>
                              <p>{toCrores(currentThroughput)} Cr</p>
                            </div>
                            <div className="membership-body-content-inner-Box-body-box-body">
                              <div className="membership-body-content-inner-Box-body-box-body-top">
                                <div className="membership-body-content-inner-Box-body-box-body-top-left">
                                  {isMilestoneAchieved ? `Achieved` : "In Progress"}
                                </div>
                                <div className="membership-body-content-inner-Box-body-box-body-top-right">
                                  {nextTier ? (
                                    pendingAmount > 0 ?
                                      <>
                                        Pending to {nextTier.name}: <span>{pendingAmount > 0 ? pendingAmount : 0} Cr</span>
                                      </> : ""
                                  ) : (
                                    "No next tier"
                                  )}
                                </div>
                              </div>
                              <div className="membership-body-content-inner-Box-body-box-body-body">
                                <div className="progress-container">
                                  <div className="progress-bar-container">
                                    <div
                                      className="progress-bar"
                                      style={{ width: `${progressPercentage}%` }}
                                    ></div>
                                  </div>
                                  <div className="tag silver-tag">
                                    <img src="images/sliver-caret.png" alt="Current Tier Achieved" />
                                    <p>{currentTierData.name}: {toCrores(currentTierData.amount)} Cr</p>
                                  </div>
                                  {nextTier && (
                                    <div className="tag gold-tag">
                                      <img src="images/gold-caret.png" alt="Next Tier Goal" />
                                      <p>{nextTier.name}: {toCrores(nextTier.amount)} Cr</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="membership-body-content-inner-Box-body-box">
                            <div className="membership-body-content-inner-Box-body-box-header">
                              <h6>Current Outstanding</h6>
                              <p>{toCrores(currentThroughputs)} Cr</p>
                            </div>
                            <div className="membership-body-content-inner-Box-body-box-body">
                              <div className="membership-body-content-inner-Box-body-box-body-top">
                                <div className="membership-body-content-inner-Box-body-box-body-top-left milestone">
                                  {isMilestoneAchieveds ? `Achieved` : "In Progress"}
                                </div>
                                <div className="membership-body-content-inner-Box-body-box-body-top-right">
                                  {pendingAmounts ? (
                                    pendingAmounts > 0 ?
                                      <>
                                        Pending to {nextTiers.name}: <span>{pendingAmounts > 0 ? pendingAmounts : 0} Cr</span>
                                      </> : ""
                                  ) : (
                                    "No next tier"
                                  )}
                                </div>
                              </div>
                              <div className="membership-body-content-inner-Box-body-box-body-body">
                                <div className="progress-container">
                                  <div className="progress-bar-container">
                                    <div
                                      className="progress-bar"
                                      style={{ width: `${progressPercentages}%` }}
                                    ></div>
                                  </div>
                                  <div className="tag silver-tag">
                                    <img src="images/sliver-caret.png" alt="Current Tier Achieved" />
                                    <p>{currentTierDatas.name}: {toCrores(currentTierDatas.amount)} Cr</p>
                                  </div>
                                  {nextTiers && (
                                    <div className="tag gold-tag">
                                      <img src="images/gold-caret.png" alt="Next Tier Goal" />
                                      <p>{nextTiers.name}: {toCrores(nextTiers.amount)} Cr</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="membership-body-content-inner-Box-body-box">
                            <div className="membership-body-content-inner-Box-body-box-header">
                              <h6>Active Retailers</h6>
                              <p>{currentRetailer}</p>
                            </div>
                            <div className="membership-body-content-inner-Box-body-box-body">
                              <div className="membership-body-content-inner-Box-body-box-body-top">
                                <div className="membership-body-content-inner-Box-body-box-body-top-left milestone">
                                  {isMilestoneRetailer ? `Achieved` : "In Progress"}
                                </div>
                                <div className="membership-body-content-inner-Box-body-box-body-top-right">
                                  {pendingRetailer > 0 && (
                                    pendingRetailer > 0 ?
                                      <>
                                        Pending to {nextRetailer.name}: <span>{pendingRetailer > 0 ? pendingRetailer : 0}</span>
                                      </> : ""
                                  )}
                                </div>
                              </div>
                              <div className="membership-body-content-inner-Box-body-box-body-body">
                                <div className="progress-container">
                                  <div className="progress-bar-container">
                                    <div
                                      className="progress-bar"
                                      style={{ width: `${progressPercentagesRetailer}%` }}
                                    ></div>
                                  </div>
                                  <div className="tag silver-tag">
                                    <img src="images/sliver-caret.png" alt="Silver Achieved" />
                                    <p>{currentTierRetailer.name}: {currentTierRetailer.amount}</p>
                                  </div>
                                  {nextRetailer && (
                                    <div className="tag gold-tag">
                                      <img src="images/gold-caret.png" alt="Gold Goal" />
                                      <p>{nextRetailer.name}: {nextRetailer.amount}</p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>}
                    {/* <div className="alert-box warning">
                    <div className="alert-box-image">
                      <img src="images/warning.png" alt="Warning Alert" />
                    </div>
                    <div className="alert-box-message">
                      <p>
                        Important: Membership will be put on hold if overdues exceed 0.5%
                        of total Outstanding
                      </p>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Membership;
